import { render } from "./NavbarBrand.vue?vue&type=template&id=0a78a8ce"
const script = {}

import exportComponent from "D:\\ASMPP\\ASMPP_VUE\\asmpp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__